import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

export default class Reviews extends withBreakpointObserver(Base) {
	static config = {
		name: 'Reviews',
        options: {
            activeBreakpoints: {
                type: String,
                default: 'xxs xs s m',
            },
        },
	};
	
	mounted() {
        setTimeout(() => {
            this.moveReviewsPaginationMobile();
            this.onClickPagination();
        }, 2000);
	}

    moveReviewsPaginationMobile() {
        const reviewsPagination = this.$el.querySelector('.stamped-pagination');
        const parent = this.$el.querySelector('.stamped-content');
    
        if (!reviewsPagination && !parent) return;
        
        parent.appendChild(reviewsPagination);
    }
    
    onClickPagination() {
        const reviewsPagination = this.$el.querySelector('.stamped-pagination');
        const paginationButtons = reviewsPagination.querySelectorAll('a');
    
        paginationButtons.forEach(button => {
            button.addEventListener('click', () => {
                setTimeout(() => {
                    moveReviewsPaginationMobile();
                }, 2000);
            });
        });
    }
}
